module.exports = function(users) {
	'use strict'
	users.directive('userDir',userDir);
	userDir.$inject=[];
	function userDir() {
		return {
			template: require('./partial/newuser.html'),
			controller:"userController",
			controllerAs:"vmu",
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/usersModule/newuser/js/directive/userDirective.js
// module id = 635
// module chunks = 0